export default __webpack_public_path__ + "static/media/trash.1ebe7eb9.svg";